/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IUser } from 'generated-types';
import { userProfileFeatureKey } from './user-profile.reducer';
import { IUserProfileState } from './user-profile.state';

const selectFeature = createFeatureSelector<IUserProfileState>(
    userProfileFeatureKey,
);

export const selectProfile = createSelector(
    selectFeature,
    (state: IUserProfileState) => state.profile,
);

export const selectTenants = createSelector(
    selectProfile,
    (profile: IUserProfileState['profile']) => profile.tenants,
);

export const selectUser = createSelector(
    selectProfile,
    (profile: IUserProfileState['profile']) => profile.user,
);

export const selectUsername = createSelector(
    selectUser,
    (user: IUser) => user.username,
);

export const selectIsSuperuser = createSelector(
    selectUser,
    (user: IUser) => user.is_superuser,
);
